<template>
  <v-container fluid class="pa-0 fill-height" style="margin-top:-30px">
  

    <!-- Layout principal : menu gauche + contenu -->
    <v-row no-gutters  class="ma-0 pa-0">
      <!-- Menu gauche -->
      <v-col cols="auto">
        <v-navigation-drawer
          permanent
          width="220"
          class="grey lighten-4"
          disable-resize-watcher
        >
        <!-- Titre du menu --><br />
    <v-subheader class="headline">Quicklooks</v-subheader>
        <v-divider></v-divider>
          <v-list dense nav>
            <v-list-item-group v-model="selected" color="primary">
              <v-list-item
                v-for="(item, i) in menuItems"
                :key="i"
                @click="currentComponent = item.component"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-navigation-drawer>
      </v-col>

      <!-- Contenu principal -->
      <v-col>
        <v-main>
          <component :is="currentComponent" />
        </v-main>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Gerfaut from './Gerfaut.vue';
import KmlMapViewer from './KmlMapViewer.vue';

export default {
  name: 'QuickLooks',
  components: {
    Gerfaut,
    KmlMapViewer
  },
  data() {
    return {
      selected: 0,
      currentComponent: 'Gerfaut',
      menuItems: [
        { title: 'Gerfaut - Picarro', component: 'Gerfaut' },
        { title: 'Flight paths', component: 'KmlMapViewer' },
        { title: 'Other quicklooks', component: 'Gerfaut' }
      ]
    };
  }
};
</script>

<style scoped>
/* Supprime les marges par défaut */
.fill-height {
  height: 100vh;
}
</style>
